import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";

import project from "../assets/projects/project.jpeg";
import lift from "../assets/projects/lift.png";

import kickstart from "../assets/projects/kickstart.png";

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lift}
              isBlog={false}
              title="Corona Tracker"
              description="This app, aptly named 'Corona Tracker,' is a powerful and indispensable tool developed with the primary goal of helping individuals stay informed and safe during the ongoing global pandemic. In these challenging times, having access to accurate and up-to-date information is paramount, and this app serves as a reliable companion in navigating the ever-evolving landscape of COVID-19."
              ghLink="https://github.com/buntychakraborty/corona-app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={project}
              isBlog={false}
              title="Text Translator"
              description="This app is essentially developed to bridge linguistic divides and make communication across languages effortless. Meet the Text Translator, your reliable companion for breaking down language barriers and fostering global connectivity.Text Translator is designed with user-friendliness in mind. Its intuitive interface ensures that even novice users can navigate with ease. Say goodbye to complex menus and confusing options; this app prioritizes simplicity."
              ghLink="https://github.com/buntychakraborty/text-translator"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kickstart}
              isBlog={false}
              title="Tiny URL Creator"
              description="This app, aptly named 'Tiny URL Creator,' is a powerful tool designed to simplify and streamline your online experience. Developed with user convenience in mind, it addresses the common challenge of managing lengthy and cumbersome web addresses.

              In an era where digital information sharing has become the norm, 'Tiny URL Creator' steps in as a handy solution. This app is basically developed to revolutionize the way we share and access online content. It takes those unwieldy, sprawling URLs and compresses them into concise, manageable links that are both easy to share and aesthetically pleasing.
              
              With 'Tiny URL Creator' at your fingertips, you'll never again struggle to share a web address in a text message or social media post. Whether you're an avid social media user, a digital marketer, or simply someone who values efficiency in online communication, this app is a must-have in your digital toolkit."
              ghLink="https://github.com/buntychakraborty/tiny-url"
            />
          </Col>


        </Row>
      </Container>
    </Container>
  )
}

export default Projects